import "./Businesshours.css";
import Header from "./Header";
import Footer from "./Footer";
import { useState } from "react";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

function Businesshours() {
  const location = useLocation(); // Get the current location (path)
  const meta = metaConfig.businesshrs;

  return (
    <div>
      <SEO {...meta} />

      {/* <!-- Navbar & Hero Start --> */}
      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>
      <div class="container-fluid Business bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "9000px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Hours of Operation
          </h4>
        </div>
      </div>

      {/* <!-- Header End -->
    
        <!-- Modal Search Start --> */}
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Modal Search End --> */}

      {/* <!-- Contact Start --> */}
      <div class="container-fluid innercontain  contact py-5">
        <div class="container py-5">
          <div class="row group_contact g-5">
            <div
              class="col-lg-10 m-auto h-100 wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div
                class="text-center mx-auto py-5"
                style={{ maxWidth: "800px" }}
              >
                <div
                  class="text-center col-lg-4 mx-auto"
                  style={{ maxWidth: "800px", fontFamily: "poppins" }}
                >
                  <h4 class="mb-3 text-white">Business Hours</h4>
                  <p class="mb-3 text-white">
                    {" "}
                    Monday to Saturday: <br />
                    9:30 AM - 6:30 PM
                    <br />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <button
        className="btn btn-secondary btn-lg-square rounded-circle back-to-top"
        onClick={() => window.scrollTo(0, 0)}
      >
        <i className="fa fa-arrow-up"></i>
      </button>
    </div>
  );
}

export default Businesshours;
